'use strict';

angular.module('team.directives.teamMemberList', [
    'teams.services.teamService'
]).directive('teamMemberList', [
    'teamService',
    function (teamService) {
        function controller() {
            this.$onChanges = function (changes) {
                if (changes.teamId) {
                    teamService.getPeopleInTeam(this.teamId)
                        .then(function (data) {
                            this.members = data;
                        }.bind(this));
                }
            }.bind(this);
        };

        return {
            restrict: 'E',
            templateUrl: '/Scripts/app/teams/directives/team-member-list.template.html',
            bindToController: {
                teamId: '<'
            },
            scope: {}, // isolated scope
            controller: controller,
            controllerAs: 'ctrl'
        };
    }]);